/**
 * Trigger a browser download for a Uint8Array result.
 *
 * Used by every tool page after a conversion completes. Creates an
 * object URL, clicks a temporary anchor, then revokes the URL on the
 * next tick so the browser has time to start the download.
 */

export function downloadBytes(
  bytes: Uint8Array,
  filename: string,
  mimeType: string = 'application/octet-stream',
): void {
  const blob = new Blob([bytes.slice().buffer], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  // Defer revoke + remove so the browser commits the download navigation.
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 100);
}
